import React, { useState } from "react";
import { SubmitHandler } from "react-hook-form";
import { z } from "zod";
import ct from "class-types.macro";
import Button from "~/common/Buttons";
import Form from "~/common/Form";
import Input from "~/common/Form/Input";
import { sendCustomerIoNewsletterSignupEvent } from "~/analytics/CustomerIo/EmailEvents";

interface FormFields {
  email: string;
}

const EmailSignUp = () => {
  const [submissionResponse, setSubmissionResponse] = useState<string>();

  const validationSchema = z.object({
    emailAddress: z
      .string()
      .nonempty("Email address is required")
      .email("Email is an invalid format"),
  });

  const defaultErrorMessage = "Error trying to join email list.";

  const defaultSuccessMessage = "Thanks for joining!";

  const onSubmit: SubmitHandler<FormFields> = async (data, event) => {
    event?.preventDefault();
    setSubmissionResponse(defaultSuccessMessage);

    const formData = new URLSearchParams();
    Object.entries(data).forEach((entry) => {
      formData.append(entry[0], entry[1]);
    });

    try {
      await fetch("/api/subscribetoallemails/", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      });

      if (formData.has("email")) {
        const email = formData.get("email");
        if (email) {
          const { emailSignupEvent } = await import("~/gtm");
          emailSignupEvent(email.toString());
          sendCustomerIoNewsletterSignupEvent(email.toString());
        }
      }
    } catch {
      setSubmissionResponse(defaultErrorMessage);
    }
  };

  return (
    <section className="newsletter">
      <div className="container">
        <div className="form-card form-card--inline">
          <div className="form-card__content">
            <div className="content-icon">
              <img
                src="//cdnimg.webstaurantstore.com/uploads/design/2019/3/holiday-everliving-email.png"
                alt=""
              />
            </div>
            <h3>Sign Up for Emails</h3>
            <p>Get notified when deals go live, receive coupons, &amp; more!</p>
          </div>

          <div className="form form--inline">
            {submissionResponse ? (
              <p>{submissionResponse}</p>
            ) : (
              <Form<FormFields>
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                <div className="form__group">
                  <div className={`${ct("pt-6")} form__control-container`}>
                    <Input name="emailAddress" label="Email address" />
                  </div>
                  <div className="form__control-container">
                    <Button type="submit" color="blue" className={ct("mt-4")}>
                      Sign Up
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmailSignUp;
